import {useConfig} from '@aboutyou/config';
import {useIsFeatureActive} from '@aboutyou/feature-flags';
import React from 'react';
import {InteractiveTileImagePreloadDeprecated} from '../../../features/ProductStream/Tiles/InteractiveTileImagePreloadDeprecated';
import {useOnColorHoverDeprecated} from '../../../features/ProductStream/Tiles/hooks/useOnColorHoverDeprecated';
import {useTileTrackingData} from '../../../features/ProductTile/hooks/useTileTrackingData';
import {
  WishlistProductTile,
  WishlistProductTileProps,
} from './WishlistProductTile';

export const InteractiveWishlistProductTile: React.FC<
  WishlistProductTileProps
> = ({tile: initialTile, itemsPreferences, ...rest}) => {
  const {isActive: openInNewTab} = useIsFeatureActive('ab_adp_new_tab');
  const {device} = useConfig();
  const {
    onHover: onColorHover,
    tile: hoveredTile,
    resetTile,
    loaded,
    onImageLoad,
    soldOut: soldOutColorProductId,
  } = useOnColorHoverDeprecated(initialTile);
  const {sendTrackingData} = useTileTrackingData();

  return (
    <>
      <WishlistProductTile
        tile={loaded && hoveredTile ? hoveredTile : initialTile}
        {...rest}
        onColorHover={onColorHover}
        onColorLeave={resetTile}
        productTileGalleryMode={
          hoveredTile && hoveredTile.product.id !== initialTile.product.id
            ? undefined
            : rest.productTileGalleryMode
        }
        itemsPreferences={itemsPreferences}
        soldOutColorProductId={soldOutColorProductId}
        openInNewTab={openInNewTab && device === 'desktop'}
        onClick={event => {
          if (rest.onClick) {
            rest.onClick(event);
          }
          if (device === 'desktop' && openInNewTab) {
            sendTrackingData(rest.trackingData, initialTile.product.id);
          }
        }}
      />
      {hoveredTile && !loaded && (
        <InteractiveTileImagePreloadDeprecated
          onImageLoad={onImageLoad}
          tile={hoveredTile}
          itemsPreferences={itemsPreferences}
          data-testid="WishlistInteractiveProductTile-preload-image"
        />
      )}
    </>
  );
};
